<script setup>
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { yautyDefaultBranding } from "@/services/api/Themes.js";
import { useOrganizationStore } from '@/stores/organization.js';
import LocalStorage from '@/controller/LocalStorage.js';
import LoginYauty from "@/components/login/LoginYauty.vue";
import LocaleSwitcher from "@/components/common/locale/LocaleSwitcher.vue";
import CookiesModal from '@/components/legal/CookiesModal.vue';
import Cookies from 'js-cookie';
import CarLoader from "@/components/common/utils/CarLoader.vue";
import { setBranding } from "@/utils/Branding.js";
import { useRouter } from 'vue-router';

const router = useRouter();
const branding = ref(LocalStorage.getBranding());
const i18n = useI18n();
const logoToSkip = 'https://yauty.com/public/assets/login/login_logo.png'; //Edge agafa aquest logo, intentem evitar-lo per evitar salts al disseny.
const imgYautyPath = ref(branding.value?.login_logo && branding.value.login_logo != '' && branding.value.login_logo != logoToSkip ? branding.value.login_logo : '../public/assets/login/login_logo.svg');
const imgLogginPath = ref(branding.value?.login_image ?? '../public/assets/login/login_w.jpg');
const yautyLogo = '/assets/logos/yauty-logo.svg';
const showCookiesModal = ref(false);
const locale = ref(i18n.locale);
const yautyLogoGrey= '/assets/logos/yauty-logo-grey.svg';

const ua = navigator.userAgent.toLowerCase();

// Per a firefox i l'app de google utilitzarm un css especific ja que tenen un comportament diferent
if (ua.includes('gsa')) {
  document.documentElement.classList.add('google-app-browser');
};

if (ua.includes('fxios')) {
  document.documentElement.classList.add('firefox-browser');
};


const organizationStore = useOrganizationStore();


const route = useRoute();
const brand = route.path.split('/').pop().toLowerCase();


const userColor = ref(LocalStorage.getColor());
const userSecondaryColor = ref(LocalStorage.getColorSecondary());
const userTertiaryColor = ref(LocalStorage.getColorTertiary());



const primaryColor = ref('');
const secondaryColor = ref('');
const tertiaryColor = ref('');

const isLoading = ref(false);

function checkBrand(brand){
	if (
		brand !== 'login' &&
		brand !== null &&
		brand !== 'undefined' &&
		brand.trim() !== '' &&
		/^[a-zA-Z0-9]+$/.test(brand)
	) {
		return true;
	} else {
		return false;
	}
}


function onChangeInput() {
  localStorage.setItem('yautyLanguage', locale.value);
}
function closeModal() {
    showCookiesModal.value = false;
}
if (typeof Cookies.get('yautyRequired') == 'undefined' || Cookies.get('yautyRequired') == 'false'){
  showCookiesModal.value = true;
}


function normalizeBrandParams(params) {
  return {
    color: params?.color ?? yautyDefaultBranding.PRIMARY_COLOR,
    secondary_color: params?.secondary_color ?? yautyDefaultBranding.SECONDARY_COLOR,
    tertiary_color: params?.tertiary_color ?? yautyDefaultBranding.TERTIARY_COLOR,
    defaultLoginImage: params?.defaultLoginImage ?? '',
    defaultLoginLogo: params?.defaultLoginLogo ?? '',
    logo: params?.logo ?? '',
    secondary_logo: params?.secondary_logo ?? '',
    login_image: params?.login_image ?? yautyDefaultBranding.LOGIN_IMAGE,
    login_logo: params?.login_logo ?? yautyDefaultBranding.LOGIN_LOGO,
  };
}

onMounted(() => {
	let brandParams = null; 
	if (checkBrand(brand)) {
		isLoading.value = true;
		
		organizationStore.getOrganizationBrandingByCode({code: brand})
			.then((res) => {
				if (res.errors){
          			router.push({ name: "login" })
          			return;
				}
				if (res && !res.errors) {
					
					if (res && res.login_logo) {
						imgYautyPath.value = res.login_logo;
					}
					if (res && res.login_image) {
						imgLogginPath.value = res.login_image;
					}
					if (res && res.color) {
						primaryColor.value = res.color;
					}
					if (res && res.secondary_color) {
						secondaryColor.value = res.secondary_color;
					}
					if (res && res.tertiary_color) {
						tertiaryColor.value = res.tertiary_color;
					}
					brandParams = {
						color: res.color,
						secondary_color: res.secondary_color,
						tertiary_color: res.tertiary_color,
						defaultLoginImage: res.defaultLoginImage,
						defaultLoginLogo: res.defaultLoginLogo,
						logo: res.logo,
						secondary_logo: res.secondary_logo,
						login_image: res.login_image,
						login_logo: res.login_logo,
					};
				}
			
			
		  
		})
		.catch((err) => {
			imgYautyPath.value = '../public/assets/login/login_logo.svg';
			brandParams = {
            color:yautyDefaultBranding.PRIMARY_COLOR,
            secondary_color: yautyDefaultBranding.SECONDARY_COLOR,
            tertiary_color: yautyDefaultBranding.TERTIARY_COLOR,
            defaultLoginImage: '',
            defaultLoginLogo: '',
            logo: '',
            secondary_logo:  '',
            login_image: yautyDefaultBranding.LOGIN_IMAGE,
            login_logo: yautyDefaultBranding.LOGIN_LOGO
          };

		})
		.finally(() => {
			isLoading.value = false;
			localStorage.setItem('yautyBranding', JSON.stringify(brandParams));
            setBranding();
            branding.value = brandParams;
		});


		

		if (primaryColor.value) {
			userColor.value = primaryColor.value;
		}
		if (secondaryColor.value) {
			userSecondaryColor.value = secondaryColor.value;
		}
		if (tertiaryColor.value) {
			userTertiaryColor.value = tertiaryColor.value;
		}
	}

	else {
		brandParams = {
			color: yautyDefaultBranding.PRIMARY_COLOR,
			secondary_color: yautyDefaultBranding.SECONDARY_COLOR,
			tertiary_color: yautyDefaultBranding.TERTIARY_COLOR,
			defaultLoginImage: '',
			defaultLoginLogo: '',
			logo: '',
			secondary_logo: '',
			login_image: yautyDefaultBranding.LOGIN_IMAGE,
			login_logo: yautyDefaultBranding.LOGIN_LOGO
		};

		const normalizedParams = normalizeBrandParams(brandParams);
		localStorage.setItem('yautyBranding', JSON.stringify(normalizedParams));
		branding.value = normalizedParams;
	}

	if (localStorage.getItem('yautyLanguage')) {
		locale.value = localStorage.getItem('yautyLanguage') ?? 'es';
	}
	

	
});

</script>
<template class="login" style="padding-left: 0px; overflow: hidden;">
  <section class="login-container">
	<div v-if="isLoading">
		<CarLoader />
    </div>
    <div v-else class="login-section--left">
      <img :src="imgLogginPath"/>
    </div>
    <div class="login-section--right">
      <div class="login-logo">
        <img :src="imgYautyPath"  style="max-width:250px;"/>
      </div>
      <div class="login-message_1">
        {{ $t("login.welcome") }}
      </div>
	  <div class="yauty-logo">
		<img :src="yautyLogo" style="width:123px;height:auto"/>
      </div>
      <div class="login-message_2">
        {{ $t("login.welcome_subtitle") }}
      </div>
      <div class="login-form">
        <LoginYauty/>
      </div>
	  <div class="powered-message grey-text">Powered by: <img :src="yautyLogoGrey" style="width: 50px; height: auto; margin-left: 5px;" /></div>
    </div>
  </section>
  <div class="language-selector">
    <div class="language__selector">
      <LocaleSwitcher :lang="locale" @changeInput="onChangeInput" :mode="1"/>
    </div>
  </div>
  <CookiesModal :show="showCookiesModal" @closeModal="closeModal()"/>
</template>

<style lang="scss" scoped>
.login-container {
  display: grid;
  background-color: white;
  grid-template-columns: 50% 50%;
  justify-content: center;
  height: calc(100vh - 60px);
  
  .login-section--left {
	width: 50dvw;
	height: 100dvh;
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
  }
  .login-section--right{
	display: flex;
	flex-direction: column;
	padding-left: 8rem;
	height: 85vh;
	@media (min-width: 1000px) and (max-width: 1299px) and (orientation: landscape) {
		flex-grow: 1;
		margin-top: 2rem;
	}
	position: relative;
	@media (min-width: 1301px) and (orientation: landscape)  {
		margin-top: 10dvh !important;
	}
	.yauty-logo{
		display: none;
	}
	.login-message_1{
		text-align: left;
		font: normal normal normal 51px/29px 'CircularStd-Book';
		letter-spacing: -2.55px;
		color: #000000;
		margin-top: 60px;
	}
	.login-message_2{
		text-align: left;
		font: normal normal normal 18px/29px 'CircularStd-Book';
		letter-spacing: -0.9px;
		color: #000000;
		opacity: 1;
		margin-top: 28px;
	}
	.powered-message {
		margin-top: auto;
		margin-bottom: 1.5rem;
		text-align: left;
		font: normal normal normal 16px/15px 'CircularStd-Book';
		letter-spacing: 0px;
		opacity: 1;
	}
	}
  @media (max-width: 1300px) {
	grid-template-columns: 0% 100%;
	.login-section--left {
		width: 0;
		img {
			width: 0;
			object-fit: cover;
		}
	}	
	.login-section--right{
		padding-left: 0rem;
		max-width: 100%;
		margin: auto;
		margin-top: 95px;
	}
  }
  @media (min-width: 1301px) {
	grid-template-columns: 40% 60%;
	.login-section--left {
		width: 40dvw;
		img {
			width: 40dvw;
			object-fit: cover;
		}
	}	
	.login-section--right{
		padding-left: 0rem;
		max-width: 100%;
		margin: auto;
		margin-top: 95px;
		left: -10.5rem
	
	}
  }
  @media (min-width: 1301px) {
	grid-template-columns: 50% 50%;
	.login-section--left {
		width: 50dvw;
		img {
			width: 50dvw;
			object-fit: cover;
		}
	}
	.login-section--right{
		padding-left: 8rem;
	}
  }
  @media (min-width: 992px) {
  }
  @media (min-width: 1200px) {
  }
  @media (min-width: 1400px) {
  }
}
.language-selector{
	position: absolute;
	bottom: -45px;
	right: 2rem;
	width: 175px;
	z-index: 5;
	margin-bottom: 0.6rem;

	 @media (min-width: 1025px){
		margin-bottom: 2.5rem;
	 }

	 @-moz-document url-prefix() {
		@media (min-width: 1025px) and (max-width: 1180px) {
			bottom: 15px;
		}
	 }
}

@media (max-width: 575px) {
	.login-container{
	height: 100% !important;
	}
	.login-logo{
		display: block !important;
		text-align: center !important;
		margin-bottom: 31px;
		margin-top: 50px;
	}
	.login-message_2{
		display: none;
	}
	.login-message_1{
		display: none;
	}

	.powered-message{
		justify-self: center;
		align-self: center;
		bottom: 2rem;
		@supports (-webkit-appearance:none) and (not (-moz-appearance:none)) and (not (-ms-ime-align:auto)) {
			bottom: 4rem;
		}
		@supports (-moz-appearance: none) {
			bottom: 5rem !important;
		}
	}

	.language-selector{
		position: absolute;
		bottom: 2dvh; 
		right: auto;
		left: 50%;
		transform: translateX(-50%);
		text-align: center;
		width: 175px;
		background: transparent;
		justify-self: center;
	}
	.login-container .login-section--right{
		margin-top: 0px;
	}
	.login-section--right{
		height: 80vh !important;
		margin-top: 10vh !important;
	}
	
}
@media (min-width: 577px) and (max-width: 1300px) and (orientation: portrait) {
	.login-container{
	height: 100% !important;
	overflow: hidden;
	}
	.login-section--right{
		height: 100vh;
		@media (min-width: 800px) and (max-width: 1299px) and (orientation: portrait) {
			height: 70vh !important;
			@media (max-width: 900px){
				height: 80dvh !important;
			}
		}
		@media (max-width: 1024px) and (orientation: portrait) {
			height: 80vh !important;
		}
	}
	.login-logo{
		display: block !important;
		text-align: center !important;
		margin-bottom: 100px;
		margin-top: 150px;
		img{
			width: 225px !important;
		}
	}
	.login-message_2{
		display: none;
	}
	.login-message_1{
		display: none;
	}
	.powered-message{
		justify-self: center;
		align-self: center;
		bottom: 2rem;
		@media (min-width: 750px) and (max-width: 850px) and (orientation: portrait) {
			bottom: 0;
			margin-bottom: 0;
		}
	}
	.language-selector{
	position: absolute;
	right: auto;

	bottom: 10dvh;
	left: 50%;
	transform: translateX(-50%);
	text-align: center;
	width: 175px;
	background: transparent;
	justify-self: center;
	}
	.login-container .login-section--right{
		margin-top: 0px;
	}
}
@media (min-width: 577px) and (max-width: 1300px) and (orientation: landscape)  {

.login-container {
  grid-template-columns: auto;
  max-width: 80%;
  margin: auto;
  align-items: center;
  justify-content: center;
  .login-section--left {
	display: none;
  }
  .login-section--right {
	position: absolute;
	max-width: 90dvh;
	margin-top: 10dvh;
	text-align: center;
	justify-self: center;
	.login-message_1, .login-message_2 {
	  text-align: center;
	}
	
  }
  .powered-message{
  justify-self: center;
  align-self: center;
  margin-top: 0rem;
}
}

@media (min-width: 577px) and (max-width: 1366px) and (orientation: landscape)  {
	.login-container{
		grid-template-columns: 0% 100%;
		@media (min-width: 1000px) and (max-width: 1299px) and (orientation: landscape) {
			height: 75dvh !important;
			top: 50px
		}

	}
	.login-section--left {
		width: 0;
		img {
			width: 0;
			object-fit: cover;
		}
	}	
	.login-section--right{
		
		padding-left: 0rem;
		max-width: 100%;
		margin: auto;
		margin-top: 18dvh;
	}
  }

}

@media (min-width: 1301px) and (max-width: 1365px) and (orientation: landscape)  {
  .login-section--right {
    padding-left: 11.4rem !important;
	margin-top: 5.1rem !important;
  }
}

@media (min-width: 1366px) and (orientation: landscape){
  .login-section--right {
    padding-left: 6rem !important;
	margin-top: 6rem !important;
  }
}

@media (max-width: 380px) {
  .language-selector{
	bottom: 15dvh;
	left: 50%;
	transform: translateX(-50%);
	text-align: center;
  }
  .powered-message{
	top: 0.5rem;
  }
  .login-section--right {
	margin-top: 2dvh !important;
  }
}

@media (min-height: 800px) and (max-width: 1300px) and (orientation: landscape) {
  .language-selector {
    position: static !important;
    margin: 2rem auto 1rem;
    padding-bottom: 1rem;
    text-align: center;
    transform: none;
  }
  
  .login-section--right {
    display: flex;
    flex-direction: column;
	min-height: 100dvh;
    height: auto !important;
    min-height: auto;
    padding-bottom: 1rem;
  }
  
  .login-container {
    height: auto !important;
    min-height: 100vh;
  }
  
  .powered-message {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 950px) and (orientation: landscape) {
  .login-section--right {
	margin-top: 15dvh !important;
	height: 150dvh !important;
	top: 0;
	padding-bottom: 8rem !important;
	max-width: none !important;
  }
  .login-container{
	height: 175dvh !important;
	min-height: 700px;
	padding-bottom: 6rem !important;
  }
  
  .language-selector {
    position: absolute !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    right: auto !important;
    margin: 0 !important;
    z-index: 10 !important;
	bottom: 2dvh !important;
  }
  
  .powered-message {
    margin-bottom: 8rem !important;
    position: relative !important;
    z-index: 1 !important;
  }
  
}

@media (min-width: 577px) and (max-width: 1024px) and (orientation: portrait) {
    :deep(button.m-btn.--sm.--rounded-full.--primary.--cursor-pointer.--is-button.--rounded) {
        font-size: 0.875rem !important;
    }
}

@media (min-width: 1000px) and (max-width: 1366px) and (orientation: landscape)  {
	.login-container{
		height: 90dvh !important;
		top: 0;
	
		.login-section--right{
			height: 75dvh !important;
		}
	}
}
 @media (min-width: 700px) and (max-width: 1300px) and (orientation: portrait) {
    .language-selector{
		bottom: 5dvh;
	}
}

@media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
	.login-section--right{
		margin-top: 4dvh !important;
	}
}


@supports (-moz-appearance: none) {
  @media (min-width: 700px) and (max-width: 1300px) and (orientation: portrait) {
    .language-selector{
		bottom: 6dvh;
	}
	.login-section--right{
		height: 87dvh !important;
	}
}
 @media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
	.login-section--right{
		margin-top: -1rem !important;
	}
	.language-selector{
		margin-bottom: 1rem;
	}
 }
}

/* Estilos específicos para Firefox */
@supports (-moz-appearance: none) {
	@media (max-width: 557px) and (orientation: portrait) {
		.login-section--right {
			height: calc(85vh + 15vh) !important;
		}
		
		.language-selector {
			bottom: calc(-45px - 15vh) !important;
		}
		
		.powered-message {
			margin-bottom: calc(1.5rem - 15vh) !important;
		}
	}
}

/* Estilos específicos para Google App */
@media (max-width: 620px) and (orientation: portrait) {
	.google-app-browser  {
		.login-section--right {
			height: calc(85vh + 15dvh) !important;
		}
		
		.language-selector {
			bottom: 0 !important;
		}
		
		.powered-message {
			margin-bottom: 0 !important;
		}
	}
	.firefox-browser  {
		.powered-message{
			margin-bottom: -3rem !important;
		}
	}
}
</style>

